// extracted by mini-css-extract-plugin
module.exports = {"activeTab":"sidebar_activeTab__-rV3X","arrow":"sidebar_arrow__JwRL6"};